import { MealTime } from "@/clients/models/MealTime";
import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import MealProgressBar from "@/components/progress/meal-progress-bar";
import { mealTabs } from "@/constants/meal-tab";
import { useGetFeedback } from "@/hooks/requests/feedback/use-get-feedback";
import { useGetCandidates } from "@/hooks/requests/go-to/use-get-candidates";
import { useSearchParams } from "@/hooks/router/use-search-params";
import { IonAlert, IonSkeletonText, useIonRouter } from "@ionic/react";
import { useState } from "react";
import GoToMealSwiper from "../../components/meal-swiper/go-to-meal-swiper";

export default function GoToAddYourPlan() {
  const navigation = useIonRouter();
  const searchParams = useSearchParams();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const mealTime =
    (searchParams.get("mealTime") as MealTime) ?? MealTime.BREAKFAST;
  const { candidates, isLoading } = useGetCandidates(mealTime);
  const currentCandidate = candidates?.[mealTime] ?? [];
  const { feedback, isLoading: isLoadingFeedback } = useGetFeedback();

  return (
    <PageContainer
      className="app-bar-bottom-padding overflow-y-auto no-scrollbar"
      showLogo={true}
    >
      <PageTitleComponent
        title="My Top Picks"
        description="Based on your top picks, we think you'll love these. You can choose up to 2 favorites."
      />

      <MealProgressBar activeMealTime={mealTime} />

      {isLoading || isLoadingFeedback ? (
        <div className="flex-1 w-full flex flex-col gap-4">
          <IonSkeletonText animated className="w-full h-[20rem]" />
          <IonSkeletonText animated className="w-full h-10" />
        </div>
      ) : (
        <GoToMealSwiper
          mealTime={mealTime}
          meals={currentCandidate}
          onCompleted={() => {
            const currentIndex = mealTabs.indexOf(mealTime);
            const nextMealTime = mealTabs[currentIndex + 1];

            if (nextMealTime) {
              const newSearchParams = new URLSearchParams(searchParams);
              newSearchParams.set("mealTime", nextMealTime);
              navigation.push(
                `${location.pathname}?${newSearchParams.toString()}`,
                "none",
              );
            } else {
              setIsDialogOpen(true);
            }
          }}
        />
      )}
      <IonAlert
        isOpen={isDialogOpen}
        header="Create a new plan now?"
        mode="ios"
        buttons={[
          {
            text: "Cancel",
            role: "cancel",
            handler: () => {
              setIsDialogOpen(false);
              if (feedback?.plan_setup) {
                navigation.push("/plans/my-plan", "forward");
              } else {
                navigation.push("/profiling/go-to/feedback", "forward");
              }
            },
          },
          {
            text: "OK",
            role: "confirm",
            handler: () => {
              navigation.push("/profiling/go-to/profiling-creating", "forward");
            },
          },
        ]}
        onDidDismiss={({ detail }) =>
          console.log(`Dismissed with role: ${detail.role}`)
        }
      />
    </PageContainer>
  );
}
